import { EventProps, TrackerConfig, TrackerEvent, UserEvent } from '../../types/services';

import { trackEvents } from '../../config/events';

const kochavaFunction = (kochavaId: string, isProd = true) => `
!function(e,t,o,a,n,c){  var r=window.kochava=window.kochava||[];if(r.loaded)window.console&&console.error&&console.error("Kochava snippet already included");else{r.loaded=!0,r.methods=["page","identify","activity","conversion","init","submitCookieId","getCookieId","getMAID","getKochavaId"],stub=function(e){return function(){var t=Array.prototype.slice.call(arguments);return t.unshift(e),r.push(t),r}};for(var i=0;i<r.methods.length;i++){var s=r.methods[i];r[s]=stub(s)}r.init((new Date).getTime(),e,n,c),function(){var e=document.createElement("script");e.type="text/javascript",e.async=!0,e.src=("https:"===document.location.protocol?"https://":"http://")+"assets.kochava.com/kochava.js/"+t+"/kochava.min.js",a||(e.src=e.src+"?c="+Math.random());var o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(e,o)}(),o&&r.page()}}("${kochavaId}","v2.1",true,${
  isProd ? 'true' : 'false'
},${isProd ? 'false' : 'false'},true);`;

const KochavaRegistrationEvent = 'Registration Complete';

class KochavaTracker extends TrackerEvent {
  valid = (key: keyof TrackerConfig) => {
    return trackEvents.kochava.enabled && trackEvents.kochava[key];
  };

  init = () => {
    if (this.valid('enabled')) {
      try {
        const env = process.env.REACT_APP_ENV;
        const kochavaId = process.env.REACT_APP_KOCHAVA_ID;
        if (!kochavaId) {
          return;
        }
        const kochavaScript = kochavaFunction(kochavaId, env === 'production');
        const scriptElement = document.createElement('script');
        scriptElement.text = kochavaScript;
        document.head.appendChild(scriptElement);
        super.init();
      } catch {}
    }
  };

  trackUser = (user: UserEvent, newUser?: boolean) => {
    if (this.inicialized && this.valid('user')) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const kochava: { identify: (userId: string, cb: () => void) => void } = (window as any)[
        'kochava'
      ];
      if (!kochava) {
        return;
      }
      kochava.identify(user.id, () => {
        if (newUser) {
          this.trackEvent(KochavaRegistrationEvent, {});
        }
      });
    }
  };

  trackEvent = (eventName: string, props: EventProps) => {
    if (this.inicialized && this.valid('event')) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const kochava: { activity: (e: string, p: any) => void } = window.kochava;
      if (!kochava) {
        return;
      }
      kochava.activity(eventName, props);
    }
  };
}

export default new KochavaTracker();
